import React from "react";
import { Link } from "react-router-dom";
import { FaLightbulb, FaUsers, FaRocket, FaRobot, FaArrowRight } from "react-icons/fa";
import "../../styles/about-links.css";

const About = () => {
  return (
    <section id="about" className="about section-padding">
      <div className="container">
        <div className="section-header">
          <h2>About Pathshala Sanchalak</h2>
          <p>Learn more about our platform and our mission</p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <h3>Who We Are</h3>
            <p>
              Pathshala Sanchalak is a comprehensive coaching and school
              management platform designed to streamline educational
              administration and enhance the learning experience. Our solution
              includes a powerful admin web portal alongside intuitive mobile
              applications for both faculty and students on iOS and Android
              platforms.
            </p>
            <div className="about-links">
              <Link to="/school-management-system" className="about-link">
                Explore School Management System <FaArrowRight />
              </Link>
              <Link to="/coaching-management-system" className="about-link">
                Discover Coaching Management System <FaArrowRight />
              </Link>
            </div>
            <p>
              Our team of education specialists and technology experts work
              collaboratively to transform educational institutions through
              digital innovation, helping schools and coaching centers operate
              efficiently and deliver outstanding educational experiences.
            </p>
            <p>
              At the core of our mission is a commitment to foster institutional
              and student growth through the power of artificial intelligence.
              We believe that AI can revolutionize education by personalizing
              learning experiences, automating administrative tasks, and
              providing data-driven insights. As we look to the future, we are
              dedicated to continuously expanding our AI capabilities to help
              educational institutions thrive in an increasingly digital world,
              ensuring that both educators and students can reach their full
              potential through technology-enhanced learning environments.
            </p>
          </div>
        </div>

        <div>
          <h3 className="values-heading">Our Mission</h3>
          <div className="about-values">
            <div className="value-card">
              <div className="value-icon">
                <FaLightbulb />
              </div>
              <h4>Educational Innovation</h4>
              <p>
                We continuously develop new features to enhance teaching and
                learning experiences for all stakeholders.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <FaRobot />
              </div>
              <h4>AI-Powered Learning</h4>
              <p>
                Our intelligent AI-driven platform provides students with 24/7
                personalized doubt resolution, enabling them to overcome
                learning obstacles at their own pace and enhancing their
                academic performance through tailored explanations and feedback.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <FaUsers />
              </div>
              <h4>Community Focus</h4>
              <p>
                We connect students, parents, and educators to build stronger
                educational communities and foster collaboration.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <FaRocket />
              </div>
              <h4>Educational Excellence</h4>
              <p>
                We are committed to empowering institutions to deliver quality
                education through powerful, user-friendly tools.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
